<template>
  <section class="hero-image d-flex align-items-center text-white">
    <div class="overlay w-100 h-100">
      <div class="container text-center py-4 py-md-5 px-3">
        <h1 class="display-6 display-md-5 fw-bold mb-3 animate__animated animate__fadeInDown">
          Bine ați venit!
        </h1>
        <p class="lead fs-6 fs-md-5 animate__animated animate__fadeInUp animate__delay-1s mx-auto hero-lead">
          Consultanță profesionistă în achiziții publice pentru autorități contractante și operatori economici.
        </p>
        <div class="d-flex flex-column flex-sm-row gap-2 justify-content-center mt-4 animate__animated animate__fadeIn animate__delay-2s">
          <router-link
            to="/contact"
            class="btn btn-light btn-md btn-lg-custom text-primary fw-semibold"
          >
            <i class="fas fa-file-alt me-2"></i> Trimite cerere
          </router-link>
          <router-link
            to="/consultanta/legislatie"
            class="btn btn-outline-light btn-md btn-lg-custom fw-semibold"
          >
            <i class="fas fa-book me-2"></i> Informații utile
          </router-link>
        </div>
        <!-- Trust badges -->
        <div class="d-flex justify-content-center gap-3 mt-4 flex-wrap animate__animated animate__fadeIn animate__delay-2s">
          <span class="badge-trust"><i class="fas fa-shield-alt me-1"></i> 10+ ani experiență</span>
          <span class="badge-trust"><i class="fas fa-users me-1"></i> Sute de clienți mulțumiți</span>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.hero-image {
  background-image: url('@/assets/hero-bg.jpg');
  background-size: cover;
  background-position: center center;
  min-height: 85vh;
  position: relative;
  overflow: hidden;
  animation: zoomInHero 20s ease-in-out infinite alternate;
}

@keyframes zoomInHero {
  0%   { background-size: 100%; }
  100% { background-size: 108%; }
}

.overlay {
  background: linear-gradient(160deg, rgba(0, 55, 90, 0.85) 0%, rgba(0, 110, 160, 0.7) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-lead {
  max-width: 600px;
}

.btn-lg-custom {
  padding: 0.55rem 1.4rem;
  font-size: 1rem;
}

.badge-trust {
  display: inline-block;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff;
  border-radius: 2rem;
  padding: 0.3rem 0.9rem;
  font-size: 0.8rem;
  font-weight: 500;
}

/* Mobile tweaks */
@media (max-width: 576px) {
  .hero-image {
    min-height: 75vh;
  }
  .display-6 {
    font-size: 1.7rem;
  }
  .lead {
    font-size: 0.97rem !important;
  }
}
</style>